import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth'
import { RegisterPage } from '@/features/auth/RegisterPage'

/**
 * Public register route.
 *
 * Story E02.02:
 *   - AC-01 preflight-redirect: an already-authenticated user who lands
 *     on `/register` directly is redirected to `/dashboard` from
 *     `beforeLoad` (parity with `/login`, story E02.01 AC-06). Throwing
 *     the redirect from `beforeLoad` prevents the form from mounting at
 *     all — there's no flash a `useEffect`-based guard would create.
 *
 * Unlike `/login`, this route accepts no search-params today. If we ever
 * wire signup-specific affiliate / invite codes (`?ref=…`, `?invite=…`)
 * we'll add `validateSearch` here — for now the schema is empty so any
 * stale query just passes through.
 */
export const Route = createFileRoute('/register')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: RegisterRouteComponent,
})

function RegisterRouteComponent() {
  return <RegisterPage />
}
